import React, { useState, useEffect, useRef } from 'react';
import { Button, Row } from 'reactstrap';

export default function PlayerDetails(props) {

  return (
    <div className="playerdetails">
      <img src={props.data.discord_avatar_url} alt="profiilikuva" className="playerImage" />
      {(props.data.items && props.data.items.length > 0) && <img src={process.env.PUBLIC_URL + "/items/" + props.data.items[0] + ".png"} alt="itemin kuva" className="playerInvItem" />}
      <h4 className="playerName">{props.data.discord_username}</h4>
      {props.points === 1 &&
        <h5 className="playerName">{props.points} piste</h5>
      }
      {(props.points && props.points !== 1) &&
        <h5 className="playerName">{props.points || 0} pistettä</h5>
      }
    </div>
  );

}
